import React from 'react'
import { MorphReplace } from 'react-svg-morph'
import PropTypes from 'prop-types'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      className="design-iconfont flex items-center justify-center"
    >
      <path d="M12.5 7.35v1.3h-9v-1.3z" />
    </svg>
  )
}
const Minus = (props) => {
  const { width, height, fill } = props
  return (
    <MorphReplace width={width} height={height} fill={fill}>
      <Icon />
    </MorphReplace>
  )
}

// 默认参数
Minus.defaultProps = {
  width: 20,
  height: 20,
  fill: 'rgb(var(--ow-primary-color))',
}
// 参数类型
Minus.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}

export default Minus
